import {
  LabelBinding,
  RequestDataOfLinkHostRequest,
  ResponseDataOfGetHostsResponse,
  ResponseDataOfGetStateResponse,
  ResponseDataOfLinkHostResponse,
} from '@monorepo-types/dc/smartthermostat';

import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

type GetHosts = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
};
/**
 *
 *
 * @returns ResponseDataOfGetHostsResponse OK
 */
export function getHosts(
  { businessUnit, label, customerId, accountId, locationId }: GetHosts,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfGetHostsResponse> {
  return request(
    {
      method: 'GET',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts`,
      errors: { 400: 'Bad Request', 403: 'Forbidden', 404: 'Not Found', 500: 'Internal Server Error' },
    },
    requestConfig,
  );
}

type GetState = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
};
/**
 *
 *
 * @returns ResponseDataOfGetStateResponse OK
 */
export function getState(
  { businessUnit, label, customerId, accountId, locationId, masterId }: GetState,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfGetStateResponse> {
  return request(
    {
      method: 'GET',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/state`,
      errors: { 400: 'Bad Request', 403: 'Forbidden', 404: 'Not Found', 500: 'Internal Server Error' },
    },
    requestConfig,
  );
}

type LinkHost = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
  requestBody: RequestDataOfLinkHostRequest;
};
/**
 *
 *
 * @returns ResponseDataOfLinkHostResponse OK
 */
export function linkHost(
  { businessUnit, label, customerId, accountId, locationId, masterId, requestBody }: LinkHost,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfLinkHostResponse> {
  return request(
    {
      method: 'POST',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/links`,
      body: requestBody,
      errors: { 400: 'Bad Request', 403: 'Forbidden', 404: 'Not Found', 500: 'Internal Server Error' },
    },
    requestConfig,
  );
}
